<template>
  <div class="table-btn">
    <template v-for="(item, index) in data">
      <span
        v-if="item || className[index]"
        :class="[className[index], isSpan ? 'myspan' : 'btn']"
        :style="{ color: colors[index] || colors[0] || '#0087ff' }"
        :key="index"
        @click.stop="doClick(event[index], className[index])"
        >{{ item }}</span
      >
    </template>
  </div>
</template>

<script>
import i18n from '@/i18n/index.js';
export default {
  name: 'MyTableBtn',
  props: {
    data: {
      // 按钮组
      type: Array,
      default: () => {
        return [i18n.t('HT.edit'), i18n.t('HT.delete')];
      }
    },
    colors: {
      // 颜色组
      type: Array,
      default: () => {
        return ['#0087ff', '#0087ff'];
      }
    },
    className: {
      // 类名
      type: Array,
      default: () => {
        return ['', ''];
      }
    },
    event: {
      //事件组
      type: Array,
      default: () => {
        return ['edit', 'delete'];
      }
    },
    isSpan: {
      //cursor样式改变
      type: Boolean,
      default: false
    }
  },

  methods: {
    /**
     * 点击事件
     * @param {String} str 事件名称
     * @param {String} className 类目
     */
    doClick(str, className) {
      if (className === 'no-click') {
        return;
      }
      this.$emit(str);
    }
  }
};
</script>

<style lang="scss" scoped>
.table-btn {
  user-select: none;

  .btn {
    margin: 0 5px;
    cursor: pointer;
    display: inline-block;
  }

  .myspan {
    margin: 0 5px;
    cursor: text;
  }

  .no-click {
    color: #777f8f80 !important;
    cursor: not-allowed;
  }
}
</style>
